import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { ForgotPasswords } from "../api/api";
import "../CounsellorAllPages/CounsellorForgotPassword.css";
import Logo from "../../assets/images/Logo.png";
import bgImage from "../../assets/images/brown-background.jpg";

const validationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
});

const CounsellorForgotPassword = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      const payload = {
        email: values.email,
        type: "counsellor",
      };

      const response = await ForgotPasswords(payload);
      console.log("Forgot Password API Response:", response);

      if (response?.success === true) {
        alert(response.msg);
        navigate("/CounsellorOtp", { state: { values } });
      } else {
        alert(response?.msg || "Failed to send OTP");
      }
    } catch (error) {
      console.error("Forgot password error:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="forgot-container"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="forgot-box">
        <img src={Logo} alt="Logo" className="login-logo" />
        <h2>Forgot Password</h2>
        <p className="forgot-text">
          Don't worry, it happens. Please enter your email, and we will send the
          OTP to it.
        </p>
        <Formik
          initialValues={{ email: "" }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className="forgot-form">
              <div className="form-group">
                {/* <label>Email</label> */}
                <Field
                  type="email"
                  name="email"
                  className="form-input"
                  placeholder="Enter your email"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="error-message"
                />
              </div>

              <button
                type="submit"
                className="forgot-button"
                disabled={isLoading || isSubmitting}
              >
                {isLoading ? "Sending..." : "Continue"}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CounsellorForgotPassword;
